import type { FC } from 'react';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import { featureFlags } from 'config/featureFlags';
import { WishAndGoal } from 'screen/WishAndGoal/WishAndGoal';
import { WishAndGoalSalesforce } from 'screen/WishAndGoalSalesforce/WishAndGoalSalesforce';
import { WuenscheUndZieleWebComponent } from './WuenscheUndZieleWebComponent';

interface WuenscheUndZieleRouteProps {
  hideFinancialGrade?: boolean;
  hideNavigation?: boolean;
  isSalesforce?: boolean;
}

/**
 * Renders the standalone dfs-wuensche-und-ziele web component once
 * `feature.vpd.wishes-and-goals-standalone` is enabled, and the screens embedded in this
 * app otherwise.
 */
export const WuenscheUndZieleRoute: FC<WuenscheUndZieleRouteProps> = ({
  hideFinancialGrade = false,
  hideNavigation = false,
  isSalesforce = false,
}) => {
  const isStandalone = useFeatureIsOn(featureFlags.wishesAndGoalsStandalone);

  if (isStandalone) {
    return (
      <WuenscheUndZieleWebComponent
        hideFinancialGrade={hideFinancialGrade}
        isSalesforce={isSalesforce}
      />
    );
  }

  return isSalesforce ? (
    <WishAndGoalSalesforce />
  ) : (
    <WishAndGoal hideFinancialGrade={hideFinancialGrade} hideNavigation={hideNavigation} />
  );
};
